<template>
    <LayoutDefault
        variant="black"
    >
        <OrganismListContainer :is-loading="load">
            <OrganismEvent />
        </OrganismListContainer>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismEvent from "../components/event/organisms/OrganismEvent.vue";
import OrganismListContainer from "../components/global/organisms/OrganismListContainer.vue";
import {mapActions, mapState} from "vuex";

export default {
    name: 'PageEvents',
    components: {
        OrganismListContainer,
        OrganismEvent,
        LayoutDefault
    },
    data() {
        return {
            load: true,
        }
    },
    mounted() {
        this.events.length === 0 ? this.handleGetEvents() : this.load = false
    },
    methods: {
        ...mapActions('event', {
            getEvents: 'getEvents'
        }),

        handleGetEvents() {
            this.getEvents({page: this.page}).then(() => this.load = false)
        },
    },
    computed: {
        ...mapState('event', {
            events: 'events'
        }),
    }
}
</script>

<style lang="scss"></style>
